import React, { useContext } from 'react';
import { SalesforceContext, Steps, CustomerTypes } from 'src/context/salesforce-context';
import { formatCurrencyAmount } from 'src/helpers/formatting';
import { CONSUMER_TYPE } from 'src/services/salesforce.service';
import TealiumEvents from 'src/helpers/tealium-events';
import './business-information-summary.scss';

export default function BusinessInformationSummary(props) {
  const { merchant, lead, customerType } = useContext(SalesforceContext);

  const addressLine1 = ['street', 'suburb']
    .map((addressItem) => merchant.account?.[addressItem])
    .filter((addressValue) => addressValue)
    .map((item, addressItemIndex) => <p key={`${0} - ${addressItemIndex}`}>{item + ', '}</p>);
  let count = 0;
  const addressLine2 = ['region', 'state', 'zip_code']
    .map((addressItem) => merchant.account?.[addressItem])
    .filter((addressValue) => {
      if (addressValue) {
        return true;
      } else {
        count++;
        return false;
      }
    })
    .map((item, addressItemIndex) => (
      <p key={`${0} - ${addressItemIndex + 2}`}>
        {addressItemIndex !== 2 - count ? item + ', ' : item}
      </p>
    ));

  count = 0;
  const addressSteps = ['street', 'suburb', 'region', 'state', 'zip_code']
    .map((addressItem) => merchant.account?.[addressItem])
    .filter((addressValue) => {
      if (addressValue) {
        return true;
      } else {
        count++;
        return false;
      }
    })
    .map((item, addressItemIndex) => (
      <p key={`${0} - ${addressItemIndex + 2}`}>
        {addressItemIndex !== 4 - count ? item + ', ' : item}
      </p>
    ));

  return (
    <div
      className={`BusinessInformationSummary input-area-container ${
        !props.isMobile ? 'container is-fluid container-padding' : ''
      }`}
    >
      {!props.isMobile && (
        <span>
          {/* <div className="section-top" /> */}
          <div className="spacer-half" />
          <div className="input-area-container-heading padding-bottom-25 has-text-left">
            <p>
              {customerType === CustomerTypes.normal && lead.consumerType === CONSUMER_TYPE.owner
                ? 'Your business information'
                : 'Business information'}
              <span
                className="is-pulled-right edit-button"
                onClick={() => {
                  TealiumEvents.confirmClickEditBusinessInfo(Steps.YOUR_BUSINESS, customerType);
                  props.quickNavigate(Steps.YOUR_BUSINESS);
                }}
                automationid="Onboarding_Create_Account_Confirm_Your_Business_Information_Span_Edit_Navigate_To_Your_Business"
              />
            </p>
          </div>
        </span>
      )}

      <div className="columns">
        <div className="column is-4 has-padding-left-0">
          <div className="columns is-multiline">
            <div className="text-block column has-padding-left-0 has-padding-right-0 is-full">
              <div className="edit-container-outer">
                <div>
                  <p className="sub-heading tiny-sub-heading">Business name</p>
                  <p className="text-body reskin_text">{merchant?.account?.business_name}</p>
                </div>
                {props.isMobile && (
                  <div className="margin-left-auto">
                    <span
                      className="edit-button is-pulled-right"
                      onClick={() => {
                        TealiumEvents.confirmClickEditBusinessInfo(
                          Steps.YOUR_BUSINESS,
                          customerType,
                        );
                        props.quickNavigate(Steps.YOUR_BUSINESS);
                      }}
                      automationid="Onboarding_Create_Account_Confirm_Your_Business_Information_Span_Edit_Navigate_To_Your_Business"
                    />
                  </div>
                )}
              </div>
            </div>

            {props.isMobile && (
              <div className="text-block column has-padding-left-0 is-full">
                <p className="sub-heading tiny-sub-heading">Monthly income</p>
                <p className="text-body reskin_text">
                  R {formatCurrencyAmount(lead?.monthlyCardTurnover)}
                </p>
              </div>
            )}

            {props.isMobile && (
              <div className="columns">
                <div className="text-block column has-padding-left-0 is-full">
                  <p className="sub-heading tiny-sub-heading">Address</p>
                  <div className="tiny-text-body">{addressLine1}</div>
                  <div className="tiny-text-body">{addressLine2}</div>
                </div>
              </div>
            )}

            <div className="text-block column has-padding-left-0 is-full">
              <p className="sub-heading tiny-sub-heading">Business type</p>
              <p className="text-body reskin_text">{merchant?.account?.business_type}</p>
            </div>

            {props.isMobile && (
              <div className="text-block column has-padding-left-0 is-full">
                <p className="sub-heading tiny-sub-heading">Industry</p>
                <p className="text-body reskin_text">{merchant?.account?.industry}</p>
              </div>
            )}

            <div className="text-block column has-padding-left-0 is-full">
              <p className="sub-heading tiny-sub-heading">Business nature</p>
              <p className="text-body reskin_text">{merchant?.account?.nature_of_business}</p>
            </div>
          </div>
        </div>

        {!props.isMobile && (
          <div className="column is-4 has-padding-left-0">
            <div className="columns is-multiline">
              <div className="text-block column has-padding-left-0 is-full">
                <p className="sub-heading tiny-sub-heading">Monthly income</p>
                <p className="text-body reskin_text">
                  R {formatCurrencyAmount(lead?.monthlyCardTurnover)}
                </p>
              </div>

              <div className="text-block column has-padding-left-0 is-full">
                <p className="sub-heading tiny-sub-heading">Industry</p>
                <p className="text-body reskin_text">{merchant?.account?.industry}</p>
              </div>
            </div>
          </div>
        )}

        {!props.isMobile && (
          <div className="column is-4 has-padding-left-0">
            <div className="columns">
              <div className="text-block column has-padding-left-0 is-full">
                <p className="sub-heading tiny-sub-heading">Business address</p>
                <div className="text-body reskin_text">{addressSteps}</div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="spacer-quarter" />
    </div>
  );
}
